var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15262_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.834 2.5C6.69232 2.5 3.33398 5.85833 3.33398 10H0.833984L4.07565 13.2417L4.13398 13.3583L7.50065 10H5.00065C5.00065 6.775 7.60898 4.16667 10.834 4.16667C14.059 4.16667 16.6673 6.775 16.6673 10C16.6673 13.225 14.059 15.8333 10.834 15.8333C9.22565 15.8333 7.76732 15.175 6.71732 14.1167L5.53398 15.3C6.89232 16.6583 8.75898 17.5 10.834 17.5C14.9757 17.5 18.334 14.1417 18.334 10C18.334 5.85833 14.9757 2.5 10.834 2.5ZM10.0007 6.66667V10.8333L13.5673 12.95L14.1673 11.9417L11.2507 10.2083V6.66667H10.0007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15262_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/History_icon.5477ef0fc60f49d28ccd9b26f915eb12.svg";
export { ForwardRef as ReactComponent };